import { FC, PropsWithChildren } from 'react';
import styles from './Filters.css';

export const Filters: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['filters']}>{children}</div>;
};
